import React, { useEffect } from 'react';
import styles from './LearnMoreDrawer.module.scss';
import CloseIcon from '../../../../../src/assets/images/icons/close-icon.svg';
import { Drawer } from '@mui/material';
import { isDrawerOpen } from '../../../../../src/features/ui/uiState';
import { useAppDispatch } from '../../../../../src/app/hooks';

export default function LearnMoreDrawer({
  showDrawer,
  setDrawer,
  editSubscription,
  content,
  position,
}) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    toggleScrolling(showDrawer);
  }, [showDrawer]);

  const toggleScrolling = (state) => {
    document.body.style.overflow = state ? 'hidden' : 'auto';
  };
  const onCloseDrawer = () => {
    if (editSubscription) {
      dispatch(isDrawerOpen(!showDrawer));
    } else {
      setDrawer(!showDrawer);
    }
  };
  return (
    <Drawer
      className={`${styles.modalDrawer}`}
      anchor={position}
      open={showDrawer}
      onClose={() => onCloseDrawer()}
      sx={{
        ['&.MuiDrawer-root']: {
          zIndex: '100000 !important',
        },
        [`& .MuiDrawer-paper`]: {
          [`&::-webkit-scrollbar`]: {
            width: '8px',
            borderRadius: '10px',
          },
          [`&::-webkit-scrollbar-track`]: {
            borderRadius: '10px',
          },
          [`&::-webkit-scrollbar-thumb`]: {
            background: '#cec7c7',
            borderRadius: '10px',
          },
          [`&::-webkit-scrollbar-thumb:hover`]: {
            background: '#a8a2a2',
          },
        },
      }}
    >
      <div className={styles.drawerWrapper}>
        <div className={styles.drawerContainer}>
          <div className={styles.drawerTitleSection}>
            <div className={styles.drawerTitle}>{content?.title}</div>
            <div className={styles.drawerCloseBtn}>
              <button
                className={styles.closeBtn}
                onClick={() => onCloseDrawer()}
              >
                <CloseIcon />
              </button>
            </div>
          </div>
          <div className={styles.drawerContent}>{content?.component}</div>
        </div>
      </div>
    </Drawer>
  );
}
